// @flow
export { default } from './BannerComment';



// WEBPACK FOOTER //
// ./src/components/banner/BannerComment/index.js